export enum EPromptAIModuleTabs {
  EmployeesUsage = 'employees-ai-usage',
  ActivityLog = 'activity-log',
}

export type PromptAITabItem = {
  label: string;
  value: EPromptAIModuleTabs;
  description?: string;
  noDescription?: boolean;
};

export const defaultPromptAITabItems: PromptAITabItem[] = [
  {
    label: 'AI Usage',
    value: EPromptAIModuleTabs.EmployeesUsage,
    description: 'Detected prompts, violations, and shadow AI activity from your workforce.',
    noDescription: true,
  },
  {
    label: 'Activity Log',
    value: EPromptAIModuleTabs.ActivityLog,
    description: 'Chronological log of prompts and responses with violation findings and actions taken.',
  },
];
